const countDownDate = new Date();
countDownDate.setHours(12, 0, 0, 0);

const pmTime = new Date();
pmTime.setHours(18, 0, 0, 0);

const countdownWrapper = document.getElementById("countdown-wrapper");

if (countdownWrapper) {
  const updateCountdown = setInterval(() => {
    const now = new Date();
    const tomorrow = new Date(now.getTime());
    tomorrow.setDate(tomorrow.getDate() + 1);

    const distance = countDownDate - now;
    const dayOfWeek = now.getDay();
    const isWeekend = dayOfWeek === 6 || dayOfWeek === 0;
    const isPm = now > pmTime;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    let countdown = hours === 0 ? `${minutes} Minuten` : `${hours} Stdn. ${minutes} Min.`;

    let info = "";
    if ((isPm && dayOfWeek !== 6 && dayOfWeek !== 5) || dayOfWeek === 0) {
      info = `Bestelle noch <span class="font-bold text-green">heute</span> und deine Bestellung wird schon <strong>morgen</strong> (${tomorrow.getDate()}.${tomorrow.getMonth() + 1}.) verschickt.`;
    } else if (distance > 0 && !isWeekend) {
      info = `Bestelle innerhalb von <span class="font-bold text-green">${countdown}</span> und wir versenden deine Bestellung noch heute.`;
    } else {
      clearInterval(updateCountdown);
      countdownWrapper.classList.add("hidden");
    }

    countdownWrapper.innerHTML = info;
    countdownWrapper.classList.remove("hidden");
  }, 1000);
}
